import Navbar from "./Navbar";
import Footer from "./Footer";

export default function PageShell({ pageClass, children }) {
  return (
    <div className={`site-shell ${pageClass}`}>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
